import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("tropikal_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("tropikal_cart", JSON.stringify(items)); }, [items]);

  const add = useCallback((product, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.product_id === product.product_id);
      if (existing) {
        return prev.map((i) => i.product_id === product.product_id ? { ...i, qty: i.qty + qty } : i);
      }
      return [...prev, { product_id: product.product_id, name: product.name, image: product.image, price: product.price, qty }];
    });
    setOpen(true);
  }, []);

  const remove = useCallback((id) => setItems((p) => p.filter((i) => i.product_id !== id)), []);
  const setQty = useCallback((id, qty) => setItems((p) => p.map((i) => i.product_id === id ? { ...i, qty: Math.max(1, qty) } : i)), []);
  const clear = useCallback(() => setItems([]), []);

  const subtotal = useMemo(() => items.reduce((s, i) => s + i.price * i.qty, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.qty, 0), [items]);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, subtotal, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
